import React, { useState, useEffect, useRef } from 'react';

const PLATFORMS = ['Google Ads', 'Meta Ads'];

export default function PlatformRotator({ prefix = 'do' }) {
  const [index, setIndex] = useState(0);
  const [glitching, setGlitching] = useState(false);
  const [text, setText] = useState(PLATFORMS[0]);

  useEffect(() => {
    const timer = setInterval(() => {
      setGlitching(true);
      setTimeout(() => {
        const next = (index + 1) % PLATFORMS.length;
        setIndex(next);
        setText(PLATFORMS[next]);
        setTimeout(() => setGlitching(false), 100);
      }, 400);
    }, 3500);
    return () => clearInterval(timer);
  }, [index]);

  const label = prefix ? `${prefix} ${text}` : text;
  // Reserve the width of the longest possible label so swapping words never
  // shifts surrounding text (e.g. "Twój Droid <rotator> pracuje 24/7").
  const widest = PLATFORMS.reduce((a, b) => (b.length > a.length ? b : a), '');
  const widestLabel = prefix ? `${prefix} ${widest}` : widest;
  return (
    <span style={{ position: 'relative', display: 'inline-block', whiteSpace: 'nowrap' }}>
      <span aria-hidden="true" style={{ visibility: 'hidden' }}>{widestLabel}</span>
      <span
        className={`platform-glitch${glitching ? ' platform-glitch-active' : ''}`}
        data-text={label}
        style={{ position: 'absolute', left: 0, top: 0, width: '100%', textAlign: 'center' }}
      >
        {label}
      </span>
    </span>
  );
}
